@if (shouldShowAlert()) {
  <cdk-accordion-item #accordionItem="cdkAccordionItem" role="button" [expanded]="isExpanded()">
    <div
      class="flex cursor-pointer flex-col justify-center overflow-hidden rounded-2xl border px-3"
      [ngClass]="{
        'border-alert-medical-border bg-alert-medical-background': isMedicalAlert(),
        'border-alert-patient-border bg-alert-patient-background': isPatientAlert(),
        'py-2': !accordionItem.expanded,
        'gap-3 pb-3 pt-2': accordionItem.expanded
      }"
      (click)="onToggleExpanded()"
    >
      <!-- Header -->
      <div class="flex w-full items-center gap-4">
        <div class="flex min-w-0 flex-1 items-center gap-1">
          <svg-icon class="shrink-0 !text-[12px]" [key]="iconKey()" [class]="iconColor()"></svg-icon>
          <h3 class="typo-h5-semibold min-w-0 flex-1 break-words" [ngClass]="titleColor()">
            {{ (isMedicalAlert() ? 'patient_alerts_medical_alert_title' : 'patient_alerts_patient_alert_title') | translate }}
          </h3>
        </div>
        <svg-icon
          class="shrink-0 transition-transform"
          [ngClass]="{ 'rotate-180': accordionItem.expanded }"
          [class]="titleColor()"
          key="px-16-chevron-down"
          size="sm"
        ></svg-icon>
      </div>

      <div [@slideToggle]="accordionItem.expanded ? 'expanded' : 'collapsed'" class="flex w-full flex-col gap-4 overflow-hidden">
        <!-- Medical Alert Content -->
        @if (isMedicalAlert()) {
          <p class="typo-h7-semibold w-full break-words text-states-deep-red-dark">
            {{ medicalAlert().alerts.join(', ') }}
          </p>
        }
        <!-- Patient Alert Content -->
        @if (isPatientAlert()) {
          <div class="flex flex-col gap-3">
            <p class="typo-h7-semibold break-words text-states-orange-dark">{{ patientAlert().description }}</p>
            <p class="typo-h7-book line-clamp-5 break-words text-states-orange-dark">{{ patientAlert().notes }}</p>
          </div>
        }
        <!-- Buttons -->
        <ffd-alert-action-buttons
          [alert]="alert()"
          (hideAlert)="onHideAlert()"
          (openHealthHistory)="onOpenHealthHistory()"
        ></ffd-alert-action-buttons>
      </div>
    </div>
  </cdk-accordion-item>
}
